<template>
  <div
    class="-publish-button-circle"
    :class="{ '-disabled': publish.disabled }"
  >
    <div
      class="icon"
      :class="styleObj"
      :title="publish.tooltipText"
      @click="$_onClickIcon"
    >
      <div
        v-if="publish.isNew && !publish.disabled"
        class="wt2-new-tag -new-tag"
      />
      <i v-if="publish.icon" :class="['wticon', 'wticon-' + publish.icon]" />
      <img v-else-if="publish.image" :src="publish.image" alt="" />
    </div>
    <div
      class="text wt2-text-s wt2-color-negative"
      :class="
        publish.disabled ? 'wt2-color-negative-disabled' : 'wt2-color-negative'
      "
      v-text="publish.text"
    />
    <transition name="wt2-fade-fast" mode="out-in">
      <component
        v-if="publish.toggleShow"
        :is="publish.component"
        @click.native="$_onClickToggledComponent"
      />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'publish-list-icon',
  props: {
    publish: { type: Object, required: true },
  },

  computed: {
    styleObj() {
      return {
        ['-icon-' + this.publish.icon]: true,
        '-progress': this.publish.progress,
      };
    },
  },

  methods: {
    $_onClickIcon(e) {
      if (this.publish.isToggle) {
        this.publish.toggleShow = !this.publish.toggleShow;
      } else {
        this.publish.run(this.publish, e);
      }
    },

    $_onClickToggledComponent(e) {
      this.publish.run(this.publish, e);
      this.publish.toggleShow = false;
    },
  },
};
</script>
